import { resolveAddressLocale, type AddressLocale } from './addressTranslations';

type StepperLabels = { decrease: string; increase: string; quantity: string };

// Accessible names for the − / + stepper. Checkout pages are localised from the
// page's locale, not i18next (see fieldMessages.ts).
const labels: Record<AddressLocale, StepperLabels> = {
  en: {
    decrease: 'Remove one {{name}}',
    increase: 'Add one {{name}}',
    quantity: '{{name}} quantity',
  },
  de: {
    decrease: 'Ein {{name}} entfernen',
    increase: 'Ein {{name}} hinzufügen',
    quantity: 'Anzahl {{name}}',
  },
  es: {
    decrease: 'Quitar un {{name}}',
    increase: 'Añadir un {{name}}',
    quantity: 'Cantidad de {{name}}',
  },
  fr: {
    decrease: 'Retirer un {{name}}',
    increase: 'Ajouter un {{name}}',
    quantity: 'Quantité de {{name}}',
  },
  it: {
    decrease: 'Rimuovi un {{name}}',
    increase: 'Aggiungi un {{name}}',
    quantity: 'Quantità di {{name}}',
  },
  nl: {
    decrease: 'Eén {{name}} verwijderen',
    increase: 'Eén {{name}} toevoegen',
    quantity: 'Aantal {{name}}',
  },
  pl: {
    decrease: 'Usuń jeden: {{name}}',
    increase: 'Dodaj jeden: {{name}}',
    quantity: 'Liczba: {{name}}',
  },
  'pt-BR': {
    decrease: 'Remover um {{name}}',
    increase: 'Adicionar um {{name}}',
    quantity: 'Quantidade de {{name}}',
  },
  'pt-PT': {
    decrease: 'Remover um {{name}}',
    increase: 'Adicionar um {{name}}',
    quantity: 'Quantidade de {{name}}',
  },
};

export function translateStepperLabel(
  locale: string | undefined,
  key: keyof StepperLabels,
  name: string,
): string {
  return labels[resolveAddressLocale(locale)][key].replace('{{name}}', name);
}
